export const decodeCampaignId = (base64ID) => {
    let decoded = atob(base64ID);
    return decoded.split(":")[1];
}
